import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminProductsSubMenusLinks from "@/components/menu/sub-menus/products/AdminProductsSubMenusLinks.vue";
import ProductList from "@/components/products/WineListComponent.vue";
export default {
  name: "adminProductList",
  components: {
    AdminProductsSubMenusLinks: AdminProductsSubMenusLinks,
    ProductList: ProductList
  },
  props: {
    loggedUserData: Object
  },
  data: function data(_this) {
    return {
      selectedTab: null,
      tabs: {
        wines: "wines",
        spirits: "spirits"
      }
    };
  },
  created: function created() {
    this.selectedTab = this.$route.query.tab || this.tabs.wines;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};